import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';
import moment from 'moment';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthorizeService } from '../_core/access-control/authorize.service';
import { FavoriteService } from '../_shared/service/favorite.service';
import { FilterService } from '../_shared/service/filter.service';
import { QuestionnaireService } from '../_shared/service/questionnaire.service';
import { SavedSearchService } from '../_shared/service/saved-search.service';
import { UserState } from '../_shared/state/user.state';
import { AppState } from '../app.state';
import { NotificationService } from '../notifications/service/notification.service';
import { ProfileService } from '../profile/profile.service';
import { ReportsService } from '../reports/reports.service';
import { ReportsState } from '../reports/reports.state';
import { SubscriptionPlanService } from '../shared/service/subscription-plan.service';
import { SearchService } from '../workspace/service/search.service';

@Injectable({
  providedIn: 'root',
})
export class VerifyLoginService {
  timeoutExecuted: boolean = false;
  reportData: any;
  onDestroyNotifier$ = new Subject();
  constructor(
    public router: Router,
    private http: HttpClient,
    private appState: AppState,
    private userState: UserState,
    private favoriteService: FavoriteService,
    private savedSearchService: SavedSearchService,
    public notificationService: NotificationService,
    private questionnaireService: QuestionnaireService,
    private reportsService: ReportsService,
    private ngZone: NgZone,
    public authorizeService: AuthorizeService,
    private profileService: ProfileService,
    private subscriptionService: SubscriptionPlanService,
    private searchService: SearchService,
    private filterService: FilterService,
    private reportState: ReportsState,
    public _pktrAppMenuService: PktrAppMenuService,
  ) {
    this.reportState.myReport$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
      this.reportData = data;
    });
  }

  verifyLogin(): Observable<any> {
    return new Observable((observer) => {
      this.appState.setAppLoadingState('verifyLogin', true);
      this.http
        .post<any>(environment.prospektrBackendBaseURL + 'validateLogin', null)
        .pipe(
          catchError(() => {
            this.appState.authTokenValue = null;
            return EMPTY;
          }),
          finalize(() => this.appState.setAppLoadingState('verifyLogin', false))
        )
        .subscribe(
          (res: any) => {
            if (res && 'user_profile' in res) {
              let navigatedTo = 'workspace';
              if (moment().isAfter(res.renewalDate, 'day')) {
                res.userRole = 'trial';
                navigatedTo = 'account-upgrade';
              } else {
                res.userRole = 'client';
                if (!res.workPlace || !res.workPlace.addressComponents) {
                  navigatedTo = 'profile';
                } else if (sessionStorage.getItem('redirectUrl')) {
                  navigatedTo = sessionStorage.getItem('redirectUrl').replace('/', '');
                }
              }
              this.userState.userDetails = res;

              this.userState.userLocation = res?.workPlace?.userLocation || '';
              this.favoriteService.fetchFollowGroupList();
              this.favoriteService.getAllFavorites();
              this.savedSearchService.getSavedSearches();
              this.filterService.setDetailedFilterForBaseFilter(null);
              this.searchService.initSubscription();

              this.subscriptionService.getSubscriptionPlan();
              this.reportsService.getPlanStatus();

              // if (this.appState.companyInfoValue.appConfig?.valueReport?.isEnabled) {
              if (this.authorizeService.canView('mls')) {
                this.profileService.getAgentMLSList().subscribe((resp) => { });
              }
              // }

              let notificationInput = {
                limit: 10,
                offset: 0,
                sortBy: 'newNotificationDate',
                sortOrder: 'desc',
                sortType: 'all',
              };
              this.notificationService.getPropertyNotifications(notificationInput);
              if (!res.user_profile.contact && !this.reportData.cmaReportId) {
                // if ( !this.reportData.cmaReportId) {
                localStorage.setItem('redirect', 'true');
                this.router.navigate(['profile'], {
                  queryParams: {
                    setup: 'phone'
                  }
                });

              }
              else {
                localStorage.setItem('redirect', 'false');
              }
              if (!this.timeoutExecuted) {
                this.timeoutExecuted = true;
                if (this.appState?.companyInfoValue?.alias != 'valuetest') {
                  this.ngZone.runOutsideAngular(() => {
                    setTimeout(() => {
                      if (this.userState.userDetails?.roles?.includes('investor')) {
                        this.ngZone.run(() => {
                          this.questionnaireService.getQuestionnaireList();
                        });
                      }
                    }, 30000);
                  });
                }
              }

              observer.next({ status: true, path: navigatedTo });
            } else {
              observer.next({ status: true, message: 'Error occurred' });
            }
          },
          (err) => {
            observer.next({
              status: true,
              message: err.error && err.error.Message ? err.error.Message : 'Error occurred',
            });
          }
        );
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
